<template>
  <AppBody
    title="Vendas / Programa de Afiliados"
    subtitle="Programas de Afiliados"
    :actions="actions"
  >
  </AppBody>
</template>

<script>
import AppBody from "@/layouts/components/AppBody.vue";
export default {
  name: "AffiliatesProgram",
  components: {
    AppBody,
  },
  data() {
    return {
      actions: [
        {
          name: "Novo Programa",
          action: () => this.openModal("new", ""),
          id: "NEW",
        },
      ],
    };
  },
};
</script>

<style style="scss" scoped>
/* Add your styles here */
</style>
